module.exports = __webpack_public_path__ + "static/media/edit.e493ea3f.svg";